<template>
  <div id="vessel-status" v-if="showVesselStatus" >
    <vs-row vs-w="12">
      <!-- 運航状態 -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="1"
        vs-sm="4"
        vs-xs="4"
      >
        <div class="common-status-column">{{ $t("Views.Vessel.Status") }}</div>
        <div class="common-status-text" :class="statusColor">
          {{ status }}
        </div>
      </vs-col>
      <!-- 速度 -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="1"
        vs-sm="4"
        vs-xs="4"
      >
        <div class="common-status-column">
          {{ $t("Views.Vessel.Velocity") }}
        </div>
        <div class="common-status-text">{{ speed }} kn</div>
      </vs-col>
      <!-- 方位 -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="1"
        vs-sm="4"
        vs-xs="4"
      >
        <div class="common-status-column">
          {{ $t("Views.Vessel.Heading") }}
        </div>
        <div class="common-status-text">{{ heading }} °</div>
      </vs-col>
      <!-- 緯度 -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="2"
        vs-sm="4"
        vs-xs="6"
      >
        <div v-if="show" class="common-status-column">
          {{ $t("Views.Vessel.Latitude") }}
        </div>
        <div v-if="show" class="common-status-text">
          {{ lat }}
        </div>
      </vs-col>
      <!-- 経度 -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="2"
        vs-sm="4"
        vs-xs="6"
      >
        <div v-if="show" class="common-status-column">
          {{ $t("Views.Vessel.Longitude") }}
        </div>
        <div v-if="show" class="common-status-text">
          {{ lng }}
        </div>
      </vs-col>
      <!-- 目的地 -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="2"
        vs-sm="4"
        vs-xs="6"
      >
        <div class="common-status-column">
          {{ $t("Views.Vessel.Destination") }}
        </div>
        <div class="common-status-text">{{ destination }}</div>
      </vs-col>
      <!-- ETA -->
      <vs-col
        class="flex-direction--column"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="2"
        vs-sm="4"
        vs-xs="6"
      >
        <div class="common-status-column">
          {{ $t("Views.Vessel.ETA") }}
        </div>
        <div class="common-status-text">{{ eta }}</div>
      </vs-col>
      <vs-col
        class="flex-direction--column vs-lg-last"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="1"
        vs-sm="4"
        vs-xs="12"
      >
        <div class="common-status-column">
          {{ $t("Views.Vessel.LastReceived") }}
        </div>
        <div class="common-status-text">{{ aisReceived }}</div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import {DateUtil, GeoUtil} from "@/utils";

  // Store
  import {createNamespacedHelpers} from "vuex";

  const {mapState: mapStateOfLiveVesselView} = createNamespacedHelpers(
    "enterpriseVesselView"
  );

  export default {
    components: {},
    props: {},
    data() {
      return {
        show: true
      };
    },
    computed: {
      ...mapStateOfLiveVesselView({
        vesselLivePosition: state => state.vesselLivePosition,
        vesselLiveAisInfo: state => state.vesselLiveAisInfo,
        vesselPositionExpired10min: state => state.vesselPositionExpired10min
      }),

      showVesselStatus(){
        return this.vesselLiveAisInfo && this.vesselLivePosition && !this.vesselPositionExpired10min
      },

      status() {
        return this.vesselLivePosition.s === 0 ? "運航中" : "停止";
      },

      statusColor() {
        return this.vesselLivePosition.s === 0 ? "text-success" : "text-danger";
      },

      speed() {
        return this.vesselLivePosition.v !== undefined
          ? this.vesselLivePosition.v
          : "0";
      },

      heading() {
        return this.vesselLivePosition.h !== undefined ||
        this.vesselLivePosition.h !== 0
          ? this.vesselLivePosition.h
          : this.vesselLivePosition.d !== undefined
            ? this.vesselLivePosition.d
            : "0.0";
      },

      lat() {
        if (this.vesselLivePosition) {
          return this.vesselLivePosition.l !== undefined
            ? `N${GeoUtil.toSexagesimalScale(this.vesselLivePosition.l._lat)}`
            : "---";
        } else {
          return "---";
        }
      },

      lng() {
        if (this.vesselLivePosition) {
          return this.vesselLivePosition.l !== undefined
            ? `E${GeoUtil.toSexagesimalScale(this.vesselLivePosition.l._long)}`
            : "---";
        } else {
          return "---";
        }
      },

      destination() {
        if (!this.vesselLiveAisInfo) return "---";
        if (this.vesselLiveAisInfo.eta) {
          return this.vesselLiveAisInfo.dt !== undefined
            ? this.vesselLiveAisInfo.dt
            : "---";
        } else {
          return "---";
        }
      },

      eta() {
        if (!this.vesselLiveAisInfo) return "---";
        if (this.vesselLiveAisInfo.eta) {
          return this.vesselLiveAisInfo.eta.seconds !== undefined
            ? DateUtil.timestampToYMDHm_jp(this.vesselLiveAisInfo.eta.seconds)
            : "---";
        } else {
          return "---";
        }
      },

      aisReceived() {
        if (this.vesselLivePosition) {
          return this.vesselLivePosition.t !== undefined
            ? DateUtil.elapsedTimeByTimestamp(this.vesselLivePosition.t)
            : "---";
        } else {
          return "---";
        }
      }
    },
    watch: {
      vesselLivePosition() {
        this.show = true;
      }
    },
    methods: {},
    created() {
    }
  };
</script>

<style lang="scss">
  @import "@/assets/scss/aisea/_mixin.scss";

  #vessel-status {
    position: relative;

    .common-status-column {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #333333;
    }

    .common-status-text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 33px;
      text-align: center;
      color: #333333;
    }

    .status-text {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      text-align: center;
      color: #3386dd;
    }

    .vs-lg-1 {
      border-right: 1px solid #ccc;
      box-sizing: border-box;
    }

    .vs-lg-2 {
      border-right: 1px solid #ccc;
      box-sizing: border-box;
    }

    .vs-lg-last {
      border-right: 1px solid #fff;
      box-sizing: border-box;
    }

    @include vs-media(xs) {

      .vs-lg-1, .vs-lg-2, .vs-lg-last {
        border: none;
        margin-bottom: 0.5rem;

      }
    }
  }
</style>
